import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = ["position", "container", "role"],
  _excluded2 = ["duration", "showTimer", "maxCount"];
// @ts-nocheck
import * as React from "react";
import { useState, useCallback, useImperativeHandle, useRef } from 'react';
import { Transition } from 'react-transition-group';
import { setupGetInstanceId, Portal } from '../utils';
var getInstanceId = setupGetInstanceId();
var useMessages = function useMessages(props) {
  var _props$maxCount = props.maxCount,
    maxCount = _props$maxCount === void 0 ? 5 : _props$maxCount;
  var _useState = useState([]),
    messages = _useState[0],
    setMessages = _useState[1];
  var getKey = useCallback(function (key) {
    if (typeof key === 'undefined' && messages !== null && messages !== void 0 && messages.length) {
      return messages[(messages === null || messages === void 0 ? void 0 : messages.length) - 1].key;
    }
    return key;
  }, [messages]);
  var push = useCallback(function (message, options, key) {
    var curMessages = [].concat(messages, [{
      key: key,
      visible: true,
      node: message
    }]);
    if (maxCount !== 0 && (curMessages === null || curMessages === void 0 ? void 0 : curMessages.length) > maxCount) return;
    setMessages([].concat(messages, [{
      key: key,
      visible: true,
      node: message,
      data: _extends({}, props, options)
    }]));
    return key;
  }, [messages, props]);
  var clear = useCallback(function () {
    // Set all existing messages to be invisible.
    setMessages(messages.map(function (msg) {
      return _extends({}, msg, {
        visible: false
      });
    }));

    // Remove all invisible messages after 400ms.
    // The delay removal here is to preserve the animation.
    setTimeout(function () {
      setMessages([]);
    }, 400);
  }, [messages]);
  var remove = useCallback(function (key) {
    // Set the message of the specified key to invisible.
    setMessages(messages.map(function (n) {
      if (n.key === getKey(key)) {
        n.visible = false;
      }
      return n;
    }));

    // Remove invisible messages after 400ms.
    setTimeout(function () {
      setMessages(messages.filter(function (msg) {
        return msg.visible;
      }));
    }, 400);
  }, [messages, getKey]);
  return {
    messages: messages,
    push: push,
    clear: clear,
    remove: remove
  };
};
var ToastManager = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var rootRef = useRef();
  var _props$position = props.position,
    position = _props$position === void 0 ? 'topCenter' : _props$position,
    container = props.container,
    role = props.role,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var _useMessages = useMessages(props),
    push = _useMessages.push,
    clear = _useMessages.clear,
    remove = _useMessages.remove,
    messages = _useMessages.messages;
  useImperativeHandle(ref, function () {
    return {
      root: rootRef.current,
      push: push,
      clear: clear,
      remove: remove
    };
  });
  var elements = messages.map(function (item, index) {
    var _item$data = item.data,
      _item$data2 = _item$data === void 0 ? {} : _item$data,
      _item$data2$duration = _item$data2.duration,
      duration = _item$data2$duration === void 0 ? 0 : _item$data2$duration,
      _item$data2$showTimer = _item$data2.showTimer,
      showTimer = _item$data2$showTimer === void 0 ? false : _item$data2$showTimer,
      maxCount = _item$data2.maxCount,
      otherData = _objectWithoutPropertiesLoose(_item$data2, _excluded2);
    return /*#__PURE__*/React.createElement(Transition, {
      key: item.key,
      "in": item.visible,
      timeout: 300,
      unmountOnExit: true
    }, function (state) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(item.node, _extends({
        position: position,
        config: true,
        showTimer: showTimer,
        duration: duration,
        // Remove the message after the specified time.
        close: function close() {
          return remove(item.key);
        },
        className: "ap-notification-fade-" + state
      }, otherData)));
    });
  });
  return /*#__PURE__*/React.createElement(Portal, {
    element: /*#__PURE__*/React.createElement("div", {
      ref: rootRef,
      role: role,
      className: "ap-notifications ap-notifications-" + position
    }, elements),
    container: container
  });
});
export default ToastManager;